// WomenInQuantumPage.jsx
import React from 'react'
import './WomenInQuantumPage.css'

export default function WomenInQuantumPage() {
  return (
    <div className="wiq-page">
      {/* Hero Section */}
      <section className="wiq-hero-section">
        <div className="wiq-container">
          <div className="wiq-hero-grid">
            <div className="wiq-hero-text">
              <h1 className="wiq-hero-title">Women in Quantum Program</h1>
              <p className="wiq-hero-subtext">
                Empowering women to lead the quantum revolution through education, mentorship, and community.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="wiq-section">
        <div className="wiq-container">
          <div className="wiq-section-header">
            <h2 className="wiq-section-title">Our Mission</h2>
            <p className="wiq-section-subtext">
              The Women in Quantum Program is dedicated to increasing diversity in quantum technology by providing resources, mentorship, and opportunities for women at all career stages.
            </p>
          </div>
          <div className="wiq-cards-grid">
            <div className="wiq-card">
              <h3 className="wiq-card-title">Education</h3>
              <p className="wiq-card-text">
                Specialized quantum computing courses and workshops designed for all skill levels.
              </p>
            </div>
            <div className="wiq-card">
              <h3 className="wiq-card-title">Mentorship</h3>
              <p className="wiq-card-text">
                Connect with leading women in quantum technology for guidance and support.
              </p>
            </div>
            <div className="wiq-card">
              <h3 className="wiq-card-title">Opportunities</h3>
              <p className="wiq-card-text">
                Access to internships, research positions, and career advancement in quantum tech.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="wiq-section">
        <div className="wiq-container">
          <h2 className="wiq-section-title">Frequently Asked Questions</h2>
          <div className="wiq-faq-grid">
            <div className="wiq-faq-item">
              <h3 className="wiq-faq-question">Who can apply?</h3>
              <p className="wiq-faq-answer">
                Any woman or non-binary person with an interest in quantum technology—no prior experience required.
              </p>
            </div>
            <div className="wiq-faq-item">
              <h3 className="wiq-faq-question">Is the program free?</h3>
              <p className="wiq-faq-answer">
                Yes, the program is completely free to ensure accessibility and inclusion.
              </p>
            </div>
            <div className="wiq-faq-item">
              <h3 className="wiq-faq-question">How long does it run?</h3>
              <p className="wiq-faq-answer">
                The program runs for 6 months, with monthly sessions and ongoing mentorship.
              </p>
            </div>
          </div>
        </div>
      </section>

            {/* Join Us Section */}
            <section className="wiq-section cta">
        <div className="wiq-container">
          <h2 className="wiq-section-title">Ready to Join the Quantum Movement?</h2>
          <p className="wiq-section-subtext">
            Be part of a transformative journey. Apply to the Women in Quantum Program today.
          </p>
          <button className="wiq-btn wiq-btn-primary">Apply Now</button>
        </div>
      </section>

    </div>
  )
}
